import { Loader } from '@trackman/web-shared-components';
import { ReactComponent as CheckThick } from 'components/icons/checkThick.svg';
import { ReactComponent as NoticeIcon } from 'components/icons/notice.svg';
import { ServiceTypes } from 'constants/ServiceTypes';
import { SyncState } from 'enums/SyncState';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ContextualDataStore } from 'stores/ContextualDataStore';
import { UiStore } from 'stores/UiStore';
import { Control, Faq, FaqLink, Indicator, SyncBarWrapper, SyncContextualData } from './SyncBarStyles';

export const SyncBar = observer(() => {
  const contextualDataStore = useInjection<ContextualDataStore>(ServiceTypes.ContextualDataStore);
  const uiStore = useInjection<UiStore>(ServiceTypes.UiStore);
  const [state, setState] = useState<SyncState>();
  const [minutes, setMinutes] = useState<string>('');
  const [hours, setHours] = useState<string>('');

  useEffect(() => {
    // Needs to be on every page, so latest sync is set when user changes page
    contextualDataStore.setLatestSync();
  }, []);

  const handleOnClickForceSync = async () => {
    await contextualDataStore.syncAllAndGetLatestSync();
  };

  useEffect(() => {
    if (
      contextualDataStore.latestSync.minutes !== undefined ||
      contextualDataStore.latestSync.hours !== undefined ||
      contextualDataStore.latestSync.days !== undefined
    ) {
      if (contextualDataStore.latestSync.days < 1) {
        setState(SyncState.upToDate);
      }

      if (contextualDataStore.latestSync.days >= 1) {
        setState(SyncState.moreThan24HoursOld);
      }

      if (contextualDataStore.latestSync.hours === 1) {
        setHours(`${contextualDataStore.latestSync.hours.toString()} hour and `);
      } else if (contextualDataStore.latestSync.hours > 1) {
        setHours(`${contextualDataStore.latestSync.hours.toString()} hours and `);
      } else if (contextualDataStore.latestSync.hours < 1) {
        setHours('');
      }
      setMinutes(contextualDataStore.latestSync.minutes.toString());
    }
  }, [contextualDataStore.latestSync]);

  return (
    <SyncBarWrapper>
      <SyncContextualData>
        <Indicator
          className={`${
            contextualDataStore.isUpdating
              ? ' updating'
              : state === SyncState.upToDate
              ? ' ok'
              : state === SyncState.moreThan24HoursOld
              ? ' old'
              : ''
          }`}
        >
          {contextualDataStore.isUpdating ? (
            <Loader size='small' />
          ) : state === SyncState.upToDate ? (
            <CheckThick />
          ) : state === SyncState.moreThan24HoursOld ? (
            <NoticeIcon color='#414141' />
          ) : null}
        </Indicator>
        <div>
          {contextualDataStore.isUpdating
            ? 'Updating Game and roster data'
            : state === SyncState.upToDate
            ? `Game and roster data synced ${hours}${minutes} min ago`
            : state === SyncState.moreThan24HoursOld
            ? 'Game and roster data is more than 24h old'
            : null}
        </div>

        <Control onClick={handleOnClickForceSync}>{contextualDataStore.isUpdating ? null : 'Force sync'}</Control>
      </SyncContextualData>
      <Faq>
        <FaqLink onClick={() => uiStore.setIsFaqModalVisible(true)}>Need help?</FaqLink>
      </Faq>
    </SyncBarWrapper>
  );
});
